import React from 'react';
import arrow from '../../assets/images/icons/arrow-down.svg'

function FullWidthImage({ className, executeScroll }) {
  return (
    <a onClick={executeScroll} className={`${className || ''} arrow_btn border border-gray rounded-circle d-flex flex-row align-items-start pointer py-0 mt-3 mt-md-2 mt-sm-40`}>
      <img className="arrow w-100 h-auto position-relative text-primary" src={arrow}></img>
    </a>
  );
}

export default FullWidthImage;